import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { GuiPlayProvider } from "./state/GuiPlayContext";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <GuiPlayProvider>
        <App />
      </GuiPlayProvider>
    </BrowserRouter>
  </StrictMode>
);
